export default __webpack_public_path__ + "static/media/HEADERS-VimeVest.32a06276.png";